import { combineReducers } from "redux";
import MerchantReducer from "./Merchant";
import RestaurentReducer from "./RestaurentReducer";
import DealReducer from "./Deals";
import promotedDealReducer from './Promotion'
import orderReducer from './Orders'
import menuReducer from './Menu'
export default combineReducers({
    MerchantReducer,
    RestaurentReducer,
    DealReducer,
    promotedDealReducer,
    orderReducer,
    menuReducer
});